import { z } from 'zod'
import type { TFunction } from '@kostbar/i18n'
import type { Role } from '@/shared/constants/roles'
import { ROLES } from '@/shared/constants/roles'

const ROLE_VALUES = Object.values(ROLES) as [Role, ...Array<Role>]

export const buildCreateUserSchema = (t: TFunction<'users'>) =>
  z.object({
    email: z.string().email(t('validation.invalidEmail')),
    password: z.string().min(6, t('validation.passwordMin')),
    roles: z.array(z.enum(ROLE_VALUES)).min(1, t('validation.rolesRequired')),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
  })

export const buildUpdateUserSchema = (t: TFunction<'users'>) =>
  z.object({
    email: z.string().email(t('validation.invalidEmail')),
    disabled: z.boolean(),
  })

export type CreateUserFormData = z.infer<
  ReturnType<typeof buildCreateUserSchema>
>
export type UpdateUserFormData = z.infer<
  ReturnType<typeof buildUpdateUserSchema>
>
